import { type FC } from "react";

export type FilePickerGuideStep = {
  label: string;
  description: string;
};

// What happens after the upload, as three numbered steps.
export const FilePickerGuide: FC<{
  steps: [FilePickerGuideStep, FilePickerGuideStep, FilePickerGuideStep];
}> = ({ steps }) => (
  <div className="mt-3 flex w-full max-w-2xl flex-wrap gap-4 text-left">
    {steps.map((step, i) => (
      <div key={i} className="flex flex-[1_1_160px] items-start gap-2.5">
        <span className="text-ink flex size-6 flex-none items-center justify-center rounded-full bg-[#f4f7fa] text-xs font-semibold shadow-[0_0_0_1px_rgba(18,53,91,.08)]">
          {i + 1}
        </span>
        <div>
          <div className="text-ink text-[13px] font-semibold">{step.label}</div>
          <div className="text-muted mt-0.5 text-xs">{step.description}</div>
        </div>
      </div>
    ))}
  </div>
);
